// =============================
// Imports
// =============================

import styled from 'styled-components';

import Cover from '../../../containers/cover';

import { headerHeight } from '../../header/mobile/variables';

// =============================
// Component
// =============================

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: calc(${headerHeight} + 4rem);
  width: 100%;
`;

export const Title = styled.h1`
  color: ${({ theme }) => theme.colors.text};
  font-size: 3rem;
  font-weight: ${({ theme }) => theme.fontWeight.extrabold};
  margin-bottom: 5rem;
  padding: 0 1.2rem;
`;

export const CoversList = styled.div`
  align-items: flex-start;
  display: flex;
  flex-wrap: wrap;
  padding: 0 1.2rem;
`;

export const StyledCover = styled(Cover).attrs(() => ({
  noBoxShadow: true,
  noScale: true,
  noTilt: true,
  noTranslateY: true,
  vynil: false,
}))`
  margin-bottom: 2rem;
  margin-right: 2rem;
  width: calc((100% - 2rem) / 2);

  &:nth-of-type(2n) {
    margin-right: 0;
  }
`;
